/* eslint-disable */

import * as IDEEutilsModule from './facade/js/util/Utils';
import * as IDEEunitsModule from './facade/js/units';
import * as IDEEuipositionModule from './facade/js/ui/position';
import * as IDEEtoastModule from './facade/js/toast';
import * as IDEEtemplateModule from './facade/js/util/Template';
import * as IDEEstyletextoverflowModule from './facade/js/style/Textoverflow';
import * as IDEEstylestateModule from './facade/js/style/State';
import * as IDEEstylequantificationModule from './facade/js/style/Quantification';
import * as IDEEstylepatternModule from './facade/js/style/Pattern';
import * as IDEEstyleheightReferenceModule from './facade/js/style/HeightReference';
import * as IDEEstyleformModule from './facade/js/style/Form';
import * as IDEEstylechartModule from './facade/js/chart/types';
import * as IDEEstylebaselineModule from './facade/js/style/Baseline';
import * as IDEEstylealignModule from './facade/js/style/Align';
import * as IDEEstyleProportionalModule from './facade/js/style/Proportional';
import * as IDEEremoteModule from './facade/js/util/Remote';
import * as IDEEparameterModule from './facade/js/parameter/parameter';
import * as IDEEloadFilesModule from './facade/js/util/LoadFiles';
import * as IDEElayertypeModule from './facade/js/layer/Type';
import * as IDEElayerMVTModule from './facade/js/layer/MVT';
import * as IDEElayerMBTilesVectorModule from './facade/js/layer/MBTilesVector';
import * as IDEElanguageModule from './facade/js/i18n/language';
import * as IDEEimplutilxmlModule from './impl/cesium/js/util/xml';
import * as IDEEimplutilwmtscapabilitiesModule from './impl/cesium/js/util/wmtscapabilities';
import * as IDEEimplutilsModule from './impl/cesium/js/util/Utils';
import * as IDEEimplstylebuilderModule from './impl/cesium/js/style/builder';
import * as IDEEimplhandlerFeatureModule from './impl/cesium/js/handler/Feature';
import * as IDEEgeomwkttypeModule from './facade/js/geom/WKT';
import * as IDEEgeomwfstypeModule from './facade/js/geom/WFS';
import * as IDEEgeomgeojsontypeModule from './facade/js/geom/GeoJSON';
import * as IDEEgeomModule from './facade/js/geom/Geom';
import * as IDEEfilterspatialModule from './facade/js/filter/Module';
import * as IDEEfilterModule from './facade/js/filter/Filter';
import * as IDEEfacadebuilderModule from './facade/js/builder/builder';
import * as IDEEevtModule from './facade/js/event/eventtype';
import * as IDEEdialogModule from './facade/js/dialog';
import * as IDEEcontrolRotateModule from './facade/js/control/Rotate';
import * as IDEEParametersModule from './facade/js/parameter/Parameters';
import * as IDEEModule from './facade/js/api-idee';
import $IDEE$window from './facade/js/util/Window';
import $IDEE$utils from './facade/js/util/Utils';
import $IDEE$ui$Panel from './facade/js/ui/Panel';
import $IDEE$style$utils from './facade/js/style/utils';
import $IDEE$style$chart$Variable from './facade/js/chart/Variable';
import $IDEE$style$Tiles3D from './facade/js/style/Tiles3D';
import $IDEE$style$Simple from './facade/js/style/Simple';
import $IDEE$style$Raster from './facade/js/style/Raster';
import $IDEE$style$Proportional from './facade/js/style/Proportional';
import $IDEE$style$Polygon from './facade/js/style/Polygon';
import $IDEE$style$Point from './facade/js/style/Point';
import $IDEE$style$Line from './facade/js/style/Line';
import $IDEE$style$Heatmap from './facade/js/style/Heatmap';
import $IDEE$style$Generic from './facade/js/style/Generic';
import $IDEE$style$Font from './facade/js/style/Font';
import $IDEE$style$FlowLine from './facade/js/style/FlowLine';
import $IDEE$style$Feature from './facade/js/style/Feature';
import $IDEE$style$Composite from './facade/js/style/Composite';
import $IDEE$style$Cluster from './facade/js/style/Cluster';
import $IDEE$style$Choropleth from './facade/js/style/Choropleth';
import $IDEE$style$Chart from './facade/js/style/Chart';
import $IDEE$style$Category from './facade/js/style/Category';
import $IDEE$stac$Catalog from './facade/js/stac/Catalog';
import $IDEE$remote$Response from './facade/js/util/Response';
import $IDEE$remote from './facade/js/util/Remote';
import $IDEE$polyfill from './facade/js/util/polyfills';
import $IDEE$parameter$xyz from './facade/js/parameter/xyz';
import $IDEE$parameter$tms from './facade/js/parameter/tms';
import $IDEE$parameter$mbtilesvector from './facade/js/parameter/mbtilesvector';
import $IDEE$parameter$mbtiles from './facade/js/parameter/mbtiles';
import $IDEE$parameter from './facade/js/parameter/parameter';
import $IDEE$layer$XYZ from './facade/js/layer/XYZ';
import $IDEE$layer$WMTS from './facade/js/layer/WMTS';
import $IDEE$layer$WMS from './facade/js/layer/WMS';
import $IDEE$layer$WMC from './facade/js/layer/WMC';
import $IDEE$layer$WFS from './facade/js/layer/WFS';
import $IDEE$layer$Vector from './facade/js/layer/Vector';
import $IDEE$layer$Tiles3D from './facade/js/layer/Tiles3D';
import $IDEE$layer$Terrain from './facade/js/layer/Terrain';
import $IDEE$layer$TMS from './facade/js/layer/TMS';
import $IDEE$layer$Section from './facade/js/layer/Section';
import $IDEE$layer$OSM from './facade/js/layer/OSM';
import $IDEE$layer$OGCAPIFeatures from './facade/js/layer/OGCAPIFeatures';
import $IDEE$layer$MapLibre from './facade/js/layer/MapLibre';
import $IDEE$layer$MVT from './facade/js/layer/MVT';
import $IDEE$layer$MBTilesVector from './facade/js/layer/MBTilesVector';
import $IDEE$layer$MBTiles from './facade/js/layer/MBTiles';
import $IDEE$layer$LayerGroup from './facade/js/layer/LayerGroup';
import $IDEE$layer$KML from './facade/js/layer/KML';
import $IDEE$layer$GeoTIFF from './facade/js/layer/GeoTIFF';
import $IDEE$layer$GeoPackageTile from './facade/js/layer/GeoPackageTile';
import $IDEE$layer$GeoPackage from './facade/js/layer/GeoPackage';
import $IDEE$layer$GeoJSON from './facade/js/layer/GeoJSON';
import $IDEE$layer$GenericVector from './facade/js/layer/GenericVector';
import $IDEE$layer$GenericRaster from './facade/js/layer/GenericRaster';
import $IDEE$impl$utils from './impl/cesium/js/util/Utils';
import $IDEE$impl$util$wmtscapabilities from './impl/cesium/js/util/wmtscapabilities';
import $IDEE$impl$style$Tiles3D from './impl/cesium/js/style/Tiles3D';
import $IDEE$impl$style$Simple from './impl/cesium/js/style/Simple';
import $IDEE$impl$style$Polygon from './impl/cesium/js/style/Polygon';
import $IDEE$impl$style$Point from './impl/cesium/js/style/Point';
import $IDEE$impl$style$Line from './impl/cesium/js/style/Line';
import $IDEE$impl$style$Generic from './impl/cesium/js/style/Generic';
import $IDEE$impl$style$Feature from './impl/cesium/js/style/Feature';
import $IDEE$impl$style$Cluster from './impl/cesium/js/style/Cluster';
import $IDEE$impl$service$WFS from './impl/cesium/js/service/WFS';
import $IDEE$impl$service$OGCAPIFeatures from './impl/cesium/js/service/OGCAPIFeatures';
import $IDEE$impl$provider$TileLoadFunctionImagineryProvider from './impl/cesium/js/provider/MBTileImageryProvider';
import $IDEE$impl$point$FontSymbol from './impl/cesium/js/point/FontSymbol';
import $IDEE$impl$loader$KML from './impl/cesium/js/loader/KML';
import $IDEE$impl$loader$JSONP from './impl/cesium/js/loader/JSONP';
import $IDEE$impl$layer$XYZ from './impl/cesium/js/layer/XYZ';
import $IDEE$impl$layer$WMTS from './impl/cesium/js/layer/WMTS';
import $IDEE$impl$layer$WMS from './impl/cesium/js/layer/WMS';
import $IDEE$impl$layer$WFS from './impl/cesium/js/layer/WFS';
import $IDEE$impl$layer$Vector from './impl/cesium/js/layer/Vector';
import $IDEE$impl$layer$Tiles3D from './impl/cesium/js/layer/Tiles3D';
import $IDEE$impl$layer$Terrain from './impl/cesium/js/layer/Terrain';
import $IDEE$impl$layer$TMS from './impl/cesium/js/layer/TMS';
import $IDEE$impl$layer$OSM from './impl/cesium/js/layer/OSM';
import $IDEE$impl$layer$OGCAPIFeatures from './impl/cesium/js/layer/OGCAPIFeatures';
import $IDEE$impl$layer$MBTiles from './impl/cesium/js/layer/MBTiles';
import $IDEE$impl$layer$KML from './impl/cesium/js/layer/KML';
import $IDEE$impl$layer$GeoJSON from './impl/cesium/js/layer/GeoJSON';
import $IDEE$impl$layer$GenericVector from './impl/cesium/js/layer/GenericVector';
import $IDEE$impl$layer$GenericRaster from './impl/cesium/js/layer/GenericRaster';
import $IDEE$impl$interaction$SelectCluster from './impl/cesium/js/interaction/SelectedCluster';
import $IDEE$impl$handler$Feature from './impl/cesium/js/handler/Feature';
import $IDEE$impl$format$XML from './impl/cesium/js/format/XML';
import $IDEE$impl$format$WMTSCapabilities from './impl/cesium/js/format/CesiumWMTSCapabilities';
import $IDEE$impl$format$WMSCapabilities from './impl/cesium/js/format/WMS';
import $IDEE$impl$format$OWS from './impl/cesium/js/format/CesiumOWS';
import $IDEE$impl$format$KML from './impl/cesium/js/format/KML';
import $IDEE$impl$format$GeoJSON from './impl/cesium/js/format/GeoJSON';
import $IDEE$impl$format$DescribeFeatureType from './impl/cesium/js/format/wfs/DescribeFeatureType';
import $IDEE$impl$format$CesiumXML from './impl/cesium/js/format/CesiumXML';
import $IDEE$impl$format$CesiumWMSCapabilities from './impl/cesium/js/format/CesiumWMSCapabilities';
import $IDEE$impl$control$Rotate from './impl/cesium/js/control/Rotate';
import $IDEE$impl$cesium$js$projections from './impl/cesium/js/projections';
import $IDEE$impl$cesium$js$ext$CesiumStyleFontSymbol from './impl/cesium/js/ext/OLStyleFontSymbol';
import $IDEE$impl$cesium$js$ext$CesiumStyleFillPattern from './impl/cesium/js/ext/CesiumStyleFillPattern';
import $IDEE$impl$Style from './impl/cesium/js/style/Style';
import $IDEE$impl$Popup from './impl/cesium/js/Popup';
import $IDEE$impl$Map from './impl/cesium/js/Map';
import $IDEE$impl$Layer from './impl/cesium/js/layer/Layer';
import $IDEE$impl$Label from './impl/cesium/js/Label';
import $IDEE$impl$GetCapabilities from './impl/cesium/js/util/WMSCapabilities';
import $IDEE$impl$Feature from './impl/cesium/js/feature/Feature';
import $IDEE$impl$Control from './impl/cesium/js/control/Control';
import $IDEE$i18n$plugins from './facade/js/i18n/plugins';
import $IDEE$handler$Feature from './facade/js/handler/Feature';
import $IDEE$handlebarshelpers from './facade/js/util/handlebarshelpers';
import $IDEE$format$WKT from './facade/js/format/WKT';
import $IDEE$format$GeoJSON from './facade/js/format/GeoJSON';
import $IDEE$filter$Spatial from './facade/js/filter/Spatial';
import $IDEE$filter$Function from './facade/js/filter/Function';
import $IDEE$filter$Base from './facade/js/filter/Base';
import $IDEE$facade$Base from './facade/js/Base';
import $IDEE$exception from './facade/js/exception/exception';
import $IDEE$evt$Listener from './facade/js/event/Listener';
import $IDEE$evt$EventsManager from './facade/js/event/Manager';
import $IDEE$control$WMCSelector from './facade/js/control/WMCSelector';
import $IDEE$control$ScaleLine from './facade/js/control/ScaleLine';
import $IDEE$control$Scale from './facade/js/control/Scale';
import $IDEE$control$Rotate from './facade/js/control/Rotate';
import $IDEE$control$Panzoombar from './facade/js/control/Panzoombar';
import $IDEE$control$Panzoom from './facade/js/control/Panzoom';
import $IDEE$control$Location from './facade/js/control/Location';
import $IDEE$control$ImplementationSwitcher from './facade/js/control/ImplementationSwitcher';
import $IDEE$control$GetFeatureInfo from './facade/js/control/GetFeatureInfo';
import $IDEE$control$BackgroundLayers from './facade/js/control/BackgroundLayers';
import $IDEE$control$Attributions from './facade/js/control/Attributions';
import $IDEE$VectorProvider from './facade/js/provider/VectorProvider';
import $IDEE$TileProvider from './facade/js/provider/TileProvider';
import $IDEE$Tile from './facade/js/provider/Tile';
import $IDEE$Style from './facade/js/style/Style';
import $IDEE$RenderFeature from './facade/js/feature/RenderFeature';
import $IDEE$Popup from './facade/js/Popup';
import $IDEE$Plugin from './facade/js/Plugin';
import $IDEE$Parameters from './facade/js/parameter/Parameters';
import $IDEE$Object from './facade/js/Object';
import $IDEE$Map from './facade/js/Map';
import $IDEE$Layer from './facade/js/layer/Layer';
import $IDEE$Label from './facade/js/Label';
import $IDEE$GeoPackageConnector from './facade/js/connector/GeoPackageConnector';
import $IDEE$Feature from './facade/js/feature/Feature';
import $IDEE$Control from './facade/js/control/Control';
import $IDEE$ClusteredFeature from './facade/js/feature/Clustered';
import $IDEE$AbstractProvider from './facade/js/provider/AbstractProvider';
const IDEE = window['IDEE'] = {};
const Cesium = window['cesium'] = {}
IDEE.AbstractProvider = $IDEE$AbstractProvider;
IDEE.ClusteredFeature = $IDEE$ClusteredFeature;
IDEE.Control = $IDEE$Control;
IDEE.Feature = $IDEE$Feature;
IDEE.GeoPackageConnector = $IDEE$GeoPackageConnector;
IDEE.Label = $IDEE$Label;
IDEE.Layer = $IDEE$Layer;
IDEE.Map = $IDEE$Map;
IDEE.Object = $IDEE$Object;
IDEE.Parameters = $IDEE$Parameters;
IDEE.Parameters.parseBGColorContainer = IDEEParametersModule.parseBGColorContainer;
IDEE.Parameters.parseBbox = IDEEParametersModule.parseBbox;
IDEE.Parameters.parseCenter = IDEEParametersModule.parseCenter;
IDEE.Parameters.parseContainer = IDEEParametersModule.parseContainer;
IDEE.Parameters.parseControls = IDEEParametersModule.parseControls;
IDEE.Parameters.parseExtentConstrains = IDEEParametersModule.parseExtentConstrains;
IDEE.Parameters.parseGetFeatureInfo = IDEEParametersModule.parseGetFeatureInfo;
IDEE.Parameters.parseKML = IDEEParametersModule.parseKML;
IDEE.Parameters.parseLabel = IDEEParametersModule.parseLabel;
IDEE.Parameters.parseLayers = IDEEParametersModule.parseLayers;
IDEE.Parameters.parseMaxExtent = IDEEParametersModule.parseMaxExtent;
IDEE.Parameters.parseMaxZoom = IDEEParametersModule.parseMaxZoom;
IDEE.Parameters.parseMinZoom = IDEEParametersModule.parseMinZoom;
IDEE.Parameters.parseProjection = IDEEParametersModule.parseProjection;
IDEE.Parameters.parseResolutions = IDEEParametersModule.parseResolutions;
IDEE.Parameters.parseRotation = IDEEParametersModule.parseRotation;
IDEE.Parameters.parseTicket = IDEEParametersModule.parseTicket;
IDEE.Parameters.parseViewExtent = IDEEParametersModule.parseViewExtent;
IDEE.Parameters.parseWMC = IDEEParametersModule.parseWMC;
IDEE.Parameters.parseWMS = IDEEParametersModule.parseWMS;
IDEE.Parameters.parseWMTS = IDEEParametersModule.parseWMTS;
IDEE.Parameters.parseZoom = IDEEParametersModule.parseZoom;
IDEE.Parameters.parseZoomConstrains = IDEEParametersModule.parseZoomConstrains;
IDEE.Plugin = $IDEE$Plugin;
IDEE.Popup = $IDEE$Popup;
IDEE.RenderFeature = $IDEE$RenderFeature;
IDEE.Style = $IDEE$Style;
IDEE.Tile = $IDEE$Tile;
IDEE.TileProvider = $IDEE$TileProvider;
IDEE.VectorProvider = $IDEE$VectorProvider;
IDEE.addQuickLayers = IDEEModule.addQuickLayers;
IDEE.config = IDEEModule.config;
IDEE.control = {};
IDEE.control.Attributions = $IDEE$control$Attributions;
IDEE.control.BackgroundLayers = $IDEE$control$BackgroundLayers;
IDEE.control.GetFeatureInfo = $IDEE$control$GetFeatureInfo;
IDEE.control.ImplementationSwitcher = $IDEE$control$ImplementationSwitcher;
IDEE.control.Location = $IDEE$control$Location;
IDEE.control.Panzoom = $IDEE$control$Panzoom;
IDEE.control.Panzoombar = $IDEE$control$Panzoombar;
IDEE.control.Rotate = $IDEE$control$Rotate;
IDEE.control.Rotate.onClick = IDEEcontrolRotateModule.onClick;
IDEE.control.Rotate.onMouseDown = IDEEcontrolRotateModule.onMouseDown;
IDEE.control.Rotate.onMouseMove = IDEEcontrolRotateModule.onMouseMove;
IDEE.control.Rotate.onMouseUp = IDEEcontrolRotateModule.onMouseUp;
IDEE.control.Scale = $IDEE$control$Scale;
IDEE.control.ScaleLine = $IDEE$control$ScaleLine;
IDEE.control.WMCSelector = $IDEE$control$WMCSelector;
IDEE.dialog = {};
IDEE.dialog.error = IDEEdialogModule.error;
IDEE.dialog.info = IDEEdialogModule.info;
IDEE.dialog.remove = IDEEdialogModule.remove;
IDEE.dialog.removeElement = IDEEdialogModule.removeElement;
IDEE.dialog.show = IDEEdialogModule.show;
IDEE.dialog.success = IDEEdialogModule.success;
IDEE.evt = {};
IDEE.evt.ACTIVATED = IDEEevtModule.ACTIVATED;
IDEE.evt.ADDED_GEOPACKAGE = IDEEevtModule.ADDED_GEOPACKAGE;
IDEE.evt.ADDED_GEOPACKAGE_TILE = IDEEevtModule.ADDED_GEOPACKAGE_TILE;
IDEE.evt.ADDED_GEOTIFF = IDEEevtModule.ADDED_GEOTIFF;
IDEE.evt.ADDED_KML = IDEEevtModule.ADDED_KML;
IDEE.evt.ADDED_LAYER = IDEEevtModule.ADDED_LAYER;
IDEE.evt.ADDED_LAYERGROUP = IDEEevtModule.ADDED_LAYERGROUP;
IDEE.evt.ADDED_MAPLIBRE = IDEEevtModule.ADDED_MAPLIBRE;
IDEE.evt.ADDED_MBTILES = IDEEevtModule.ADDED_MBTILES;
IDEE.evt.ADDED_MBTILES_VECTOR = IDEEevtModule.ADDED_MBTILES_VECTOR;
IDEE.evt.ADDED_OGCAPIFEATURES = IDEEevtModule.ADDED_OGCAPIFEATURES;
IDEE.evt.ADDED_QUICK_LAYERS = IDEEevtModule.ADDED_QUICK_LAYERS;
IDEE.evt.ADDED_TERRAIN = IDEEevtModule.ADDED_TERRAIN;
IDEE.evt.ADDED_TILES3D = IDEEevtModule.ADDED_TILES3D;
IDEE.evt.ADDED_TMS = IDEEevtModule.ADDED_TMS;
IDEE.evt.ADDED_TO_LAYERGROUP = IDEEevtModule.ADDED_TO_LAYERGROUP;
IDEE.evt.ADDED_TO_MAP = IDEEevtModule.ADDED_TO_MAP;
IDEE.evt.ADDED_TO_PANEL = IDEEevtModule.ADDED_TO_PANEL;
IDEE.evt.ADDED_VECTOR_TILE = IDEEevtModule.ADDED_VECTOR_TILE;
IDEE.evt.ADDED_WFS = IDEEevtModule.ADDED_WFS;
IDEE.evt.ADDED_WMC = IDEEevtModule.ADDED_WMC;
IDEE.evt.ADDED_WMS = IDEEevtModule.ADDED_WMS;
IDEE.evt.ADDED_WMTS = IDEEevtModule.ADDED_WMTS;
IDEE.evt.ADDED_XYZ = IDEEevtModule.ADDED_XYZ;
IDEE.evt.CHANGE = IDEEevtModule.CHANGE;
IDEE.evt.CHANGE_PROJ = IDEEevtModule.CHANGE_PROJ;
IDEE.evt.CHANGE_ROTATION = IDEEevtModule.CHANGE_ROTATION;
IDEE.evt.CHANGE_STYLE = IDEEevtModule.CHANGE_STYLE;
IDEE.evt.CHANGE_WMC = IDEEevtModule.CHANGE_WMC;
IDEE.evt.CHANGE_ZOOM = IDEEevtModule.CHANGE_ZOOM;
IDEE.evt.CLICK = IDEEevtModule.CLICK;
IDEE.evt.COMPLETED = IDEEevtModule.COMPLETED;
IDEE.evt.COMPLETED_CHANGE_STYLE_FEATURE = IDEEevtModule.COMPLETED_CHANGE_STYLE_FEATURE;
IDEE.evt.DEACTIVATED = IDEEevtModule.DEACTIVATED;
IDEE.evt.DESTROY = IDEEevtModule.DESTROY;
IDEE.evt.EventsManager = $IDEE$evt$EventsManager;
IDEE.evt.HIDE = IDEEevtModule.HIDE;
IDEE.evt.HOVER_FEATURES = IDEEevtModule.HOVER_FEATURES;
IDEE.evt.LAYER_VISIBILITY_CHANGE = IDEEevtModule.LAYER_VISIBILITY_CHANGE;
IDEE.evt.LEAVE_FEATURES = IDEEevtModule.LEAVE_FEATURES;
IDEE.evt.LOAD = IDEEevtModule.LOAD;
IDEE.evt.LOAD_ALL_TILES = IDEEevtModule.LOAD_ALL_TILES;
IDEE.evt.LOAD_GENERIC_VECTOR = IDEEevtModule.LOAD_GENERIC_VECTOR;
IDEE.evt.LOAD_LAYERS = IDEEevtModule.LOAD_LAYERS;
IDEE.evt.LOAD_TERRAIN = IDEEevtModule.LOAD_TERRAIN;
IDEE.evt.Listener = $IDEE$evt$Listener;
IDEE.evt.MOVE = IDEEevtModule.MOVE;
IDEE.evt.MOVE_MOUSE = IDEEevtModule.MOVE_MOUSE;
IDEE.evt.POPUP_ADDED = IDEEevtModule.POPUP_ADDED;
IDEE.evt.POPUP_ADDED_TAB = IDEEevtModule.POPUP_ADDED_TAB;
IDEE.evt.POPUP_REMOVED = IDEEevtModule.POPUP_REMOVED;
IDEE.evt.POPUP_REMOVED_TAB = IDEEevtModule.POPUP_REMOVED_TAB;
IDEE.evt.REMOVED_FROM_LAYERGROUP = IDEEevtModule.REMOVED_FROM_LAYERGROUP;
IDEE.evt.REMOVED_FROM_MAP = IDEEevtModule.REMOVED_FROM_MAP;
IDEE.evt.REMOVED_LAYER = IDEEevtModule.REMOVED_LAYER;
IDEE.evt.SELECT_FEATURES = IDEEevtModule.SELECT_FEATURES;
IDEE.evt.SHOW = IDEEevtModule.SHOW;
IDEE.evt.UNSELECT_FEATURES = IDEEevtModule.UNSELECT_FEATURES;
IDEE.exception = $IDEE$exception;
IDEE.facade = {};
IDEE.facade.Base = $IDEE$facade$Base;
IDEE.facade.builder = {};
IDEE.facade.builder.getBackgroundLayersPanel = IDEEfacadebuilderModule.getBackgroundLayersPanel;
IDEE.facade.builder.getImplementationSwitcherPanel = IDEEfacadebuilderModule.getImplementationSwitcherPanel;
IDEE.facade.builder.getLocationPanel = IDEEfacadebuilderModule.getLocationPanel;
IDEE.facade.builder.getPanzoomPanel = IDEEfacadebuilderModule.getPanzoomPanel;
IDEE.facade.builder.getPanzoombarPanel = IDEEfacadebuilderModule.getPanzoombarPanel;
IDEE.facade.builder.getRotatePanel = IDEEfacadebuilderModule.getRotatePanel;
IDEE.facade.builder.getScaleLinePanel = IDEEfacadebuilderModule.getScaleLinePanel;
IDEE.facade.builder.getScalePanel = IDEEfacadebuilderModule.getScalePanel;
IDEE.facade.builder.getWMCSelectorPanel = IDEEfacadebuilderModule.getWMCSelectorPanel;
IDEE.filter = {};
IDEE.filter.AND = IDEEfilterModule.AND;
IDEE.filter.Base = $IDEE$filter$Base;
IDEE.filter.EQUAL = IDEEfilterModule.EQUAL;
IDEE.filter.Function = $IDEE$filter$Function;
IDEE.filter.GT = IDEEfilterModule.GT;
IDEE.filter.GTE = IDEEfilterModule.GTE;
IDEE.filter.LIKE = IDEEfilterModule.LIKE;
IDEE.filter.LT = IDEEfilterModule.LT;
IDEE.filter.LTE = IDEEfilterModule.LTE;
IDEE.filter.NOT = IDEEfilterModule.NOT;
IDEE.filter.OR = IDEEfilterModule.OR;
IDEE.filter.Spatial = $IDEE$filter$Spatial;
IDEE.filter.spatial = {};
IDEE.filter.spatial.CONTAIN = IDEEfilterspatialModule.CONTAIN;
IDEE.filter.spatial.DISJOINT = IDEEfilterspatialModule.DISJOINT;
IDEE.filter.spatial.INTERSECT = IDEEfilterspatialModule.INTERSECT;
IDEE.filter.spatial.WITHIN = IDEEfilterspatialModule.WITHIN;
IDEE.filter.spatial.parseParamToGeometries = IDEEfilterspatialModule.parseParamToGeometries;
IDEE.format = {};
IDEE.format.GeoJSON = $IDEE$format$GeoJSON;
IDEE.format.WKT = $IDEE$format$WKT;
IDEE.geom = {};
IDEE.geom.geojson = {};
IDEE.geom.geojson.type = {};
IDEE.geom.geojson.type.GEOMETRY_COLLECTION = IDEEgeomgeojsontypeModule.GEOMETRY_COLLECTION;
IDEE.geom.geojson.type.LINE_STRING = IDEEgeomgeojsontypeModule.LINE_STRING;
IDEE.geom.geojson.type.MULTI_LINE_STRING = IDEEgeomgeojsontypeModule.MULTI_LINE_STRING;
IDEE.geom.geojson.type.MULTI_POINT = IDEEgeomgeojsontypeModule.MULTI_POINT;
IDEE.geom.geojson.type.MULTI_POLYGON = IDEEgeomgeojsontypeModule.MULTI_POLYGON;
IDEE.geom.geojson.type.POINT = IDEEgeomgeojsontypeModule.POINT;
IDEE.geom.geojson.type.POLYGON = IDEEgeomgeojsontypeModule.POLYGON;
IDEE.geom.parse = IDEEgeomModule.parse;
IDEE.geom.parseWFS = IDEEgeomModule.parseWFS;
IDEE.geom.wfs = {};
IDEE.geom.wfs.type = {};
IDEE.geom.wfs.type.LINE = IDEEgeomwfstypeModule.LINE;
IDEE.geom.wfs.type.MLINE = IDEEgeomwfstypeModule.MLINE;
IDEE.geom.wfs.type.MPOINT = IDEEgeomwfstypeModule.MPOINT;
IDEE.geom.wfs.type.MPOLYGON = IDEEgeomwfstypeModule.MPOLYGON;
IDEE.geom.wfs.type.POINT = IDEEgeomwfstypeModule.POINT;
IDEE.geom.wfs.type.POLYGON = IDEEgeomwfstypeModule.POLYGON;
IDEE.geom.wkt = {};
IDEE.geom.wkt.type = {};
IDEE.geom.wkt.type.CIRCLE = IDEEgeomwkttypeModule.CIRCLE;
IDEE.geom.wkt.type.GEOMETRY = IDEEgeomwkttypeModule.GEOMETRY;
IDEE.geom.wkt.type.GEOMETRY_COLLECTION = IDEEgeomwkttypeModule.GEOMETRY_COLLECTION;
IDEE.geom.wkt.type.LINEAR_RING = IDEEgeomwkttypeModule.LINEAR_RING;
IDEE.geom.wkt.type.LINE_STRING = IDEEgeomwkttypeModule.LINE_STRING;
IDEE.geom.wkt.type.MULTI_LINE_STRING = IDEEgeomwkttypeModule.MULTI_LINE_STRING;
IDEE.geom.wkt.type.MULTI_POINT = IDEEgeomwkttypeModule.MULTI_POINT;
IDEE.geom.wkt.type.MULTI_POLYGON = IDEEgeomwkttypeModule.MULTI_POLYGON;
IDEE.geom.wkt.type.POINT = IDEEgeomwkttypeModule.POINT;
IDEE.geom.wkt.type.POLYGON = IDEEgeomwkttypeModule.POLYGON;
IDEE.getQuickLayers = IDEEModule.getQuickLayers;
IDEE.handlebarshelpers = $IDEE$handlebarshelpers;
IDEE.handler = {};
IDEE.handler.Feature = $IDEE$handler$Feature;
IDEE.i18n = {};
IDEE.i18n.plugins = $IDEE$i18n$plugins;
IDEE.impl = {};
IDEE.impl.Control = $IDEE$impl$Control;
IDEE.impl.Feature = $IDEE$impl$Feature;
IDEE.impl.GetCapabilities = $IDEE$impl$GetCapabilities;
IDEE.impl.Label = $IDEE$impl$Label;
IDEE.impl.Layer = $IDEE$impl$Layer;
IDEE.impl.Map = $IDEE$impl$Map;
IDEE.impl.Popup = $IDEE$impl$Popup;
IDEE.impl.Style = $IDEE$impl$Style;
IDEE.impl.cesium = {};
IDEE.impl.cesium.js = {};
IDEE.impl.cesium.js.ext = {};
IDEE.impl.cesium.js.ext.CesiumStyleFillPattern = $IDEE$impl$cesium$js$ext$CesiumStyleFillPattern;
IDEE.impl.cesium.js.ext.CesiumStyleFontSymbol = $IDEE$impl$cesium$js$ext$CesiumStyleFontSymbol;
IDEE.impl.cesium.js.projections = $IDEE$impl$cesium$js$projections;
IDEE.impl.control = {};
IDEE.impl.control.Rotate = $IDEE$impl$control$Rotate;
IDEE.impl.format = {};
IDEE.impl.format.CesiumWMSCapabilities = $IDEE$impl$format$CesiumWMSCapabilities;
IDEE.impl.format.CesiumXML = $IDEE$impl$format$CesiumXML;
IDEE.impl.format.DescribeFeatureType = $IDEE$impl$format$DescribeFeatureType;
IDEE.impl.format.GeoJSON = $IDEE$impl$format$GeoJSON;
IDEE.impl.format.KML = $IDEE$impl$format$KML;
IDEE.impl.format.OWS = $IDEE$impl$format$OWS;
IDEE.impl.format.WMSCapabilities = $IDEE$impl$format$WMSCapabilities;
IDEE.impl.format.WMTSCapabilities = $IDEE$impl$format$WMTSCapabilities;
IDEE.impl.format.XML = $IDEE$impl$format$XML;
IDEE.impl.handler = {};
IDEE.impl.handler.Feature = $IDEE$impl$handler$Feature;
IDEE.impl.handler.Feature.getFacadeFeature = IDEEimplhandlerFeatureModule.getFacadeFeature;
IDEE.impl.interaction = {};
IDEE.impl.interaction.SelectCluster = $IDEE$impl$interaction$SelectCluster;
IDEE.impl.layer = {};
IDEE.impl.layer.GenericRaster = $IDEE$impl$layer$GenericRaster;
IDEE.impl.layer.GenericVector = $IDEE$impl$layer$GenericVector;
IDEE.impl.layer.GeoJSON = $IDEE$impl$layer$GeoJSON;
IDEE.impl.layer.KML = $IDEE$impl$layer$KML;
IDEE.impl.layer.MBTiles = $IDEE$impl$layer$MBTiles;
IDEE.impl.layer.OGCAPIFeatures = $IDEE$impl$layer$OGCAPIFeatures;
IDEE.impl.layer.OSM = $IDEE$impl$layer$OSM;
IDEE.impl.layer.TMS = $IDEE$impl$layer$TMS;
IDEE.impl.layer.Terrain = $IDEE$impl$layer$Terrain;
IDEE.impl.layer.Tiles3D = $IDEE$impl$layer$Tiles3D;
IDEE.impl.layer.Vector = $IDEE$impl$layer$Vector;
IDEE.impl.layer.WFS = $IDEE$impl$layer$WFS;
IDEE.impl.layer.WMS = $IDEE$impl$layer$WMS;
IDEE.impl.layer.WMTS = $IDEE$impl$layer$WMTS;
IDEE.impl.layer.XYZ = $IDEE$impl$layer$XYZ;
IDEE.impl.loader = {};
IDEE.impl.loader.JSONP = $IDEE$impl$loader$JSONP;
IDEE.impl.loader.KML = $IDEE$impl$loader$KML;
IDEE.impl.point = {};
IDEE.impl.point.FontSymbol = $IDEE$impl$point$FontSymbol;
IDEE.impl.provider = {};
IDEE.impl.provider.TileLoadFunctionImagineryProvider = $IDEE$impl$provider$TileLoadFunctionImagineryProvider;
IDEE.impl.service = {};
IDEE.impl.service.OGCAPIFeatures = $IDEE$impl$service$OGCAPIFeatures;
IDEE.impl.service.WFS = $IDEE$impl$service$WFS;
IDEE.impl.style = {};
IDEE.impl.style.Cluster = $IDEE$impl$style$Cluster;
IDEE.impl.style.Feature = $IDEE$impl$style$Feature;
IDEE.impl.style.Generic = $IDEE$impl$style$Generic;
IDEE.impl.style.Line = $IDEE$impl$style$Line;
IDEE.impl.style.Point = $IDEE$impl$style$Point;
IDEE.impl.style.Polygon = $IDEE$impl$style$Polygon;
IDEE.impl.style.Simple = $IDEE$impl$style$Simple;
IDEE.impl.style.Tiles3D = $IDEE$impl$style$Tiles3D;
IDEE.impl.style.builder = {};
IDEE.impl.style.builder.getExtrudedHeight = IDEEimplstylebuilderModule.getExtrudedHeight;
IDEE.impl.style.builder.getExtrudedHeightReference = IDEEimplstylebuilderModule.getExtrudedHeightReference;
IDEE.impl.style.builder.getFill = IDEEimplstylebuilderModule.getFill;
IDEE.impl.style.builder.getFillPatern = IDEEimplstylebuilderModule.getFillPatern;
IDEE.impl.style.builder.getHeightReference = IDEEimplstylebuilderModule.getHeightReference;
IDEE.impl.style.builder.getIconForm = IDEEimplstylebuilderModule.getIconForm;
IDEE.impl.style.builder.getIconSrc = IDEEimplstylebuilderModule.getIconSrc;
IDEE.impl.style.builder.getLabel = IDEEimplstylebuilderModule.getLabel;
IDEE.impl.style.builder.getLineFill = IDEEimplstylebuilderModule.getLineFill;
IDEE.impl.style.builder.getLineStroke = IDEEimplstylebuilderModule.getLineStroke;
IDEE.impl.style.builder.getLineStyle = IDEEimplstylebuilderModule.getLineStyle;
IDEE.impl.style.builder.getLineText = IDEEimplstylebuilderModule.getLineText;
IDEE.impl.style.builder.getPerPositionHeight = IDEEimplstylebuilderModule.getPerPositionHeight;
IDEE.impl.style.builder.getPointStyle = IDEEimplstylebuilderModule.getPointStyle;
IDEE.impl.style.builder.getPolygonStyle = IDEEimplstylebuilderModule.getPolygonStyle;
IDEE.impl.style.builder.getStroke = IDEEimplstylebuilderModule.getStroke;
IDEE.impl.style.builder.getStrokePatern = IDEEimplstylebuilderModule.getStrokePatern;
IDEE.impl.style.builder.iconCache = IDEEimplstylebuilderModule.iconCache;
IDEE.impl.util = {};
IDEE.impl.util.wmtscapabilities = $IDEE$impl$util$wmtscapabilities;
IDEE.impl.util.wmtscapabilities = $IDEE$impl$util$wmtscapabilities;
IDEE.impl.util.wmtscapabilities.getLayers = IDEEimplutilwmtscapabilitiesModule.getLayers;
IDEE.impl.util.xml = {};
IDEE.impl.util.xml.boundingExtent = IDEEimplutilxmlModule.boundingExtent;
IDEE.impl.util.xml.createEmpty = IDEEimplutilxmlModule.createEmpty;
IDEE.impl.util.xml.getAllTextContent = IDEEimplutilxmlModule.getAllTextContent;
IDEE.impl.utils = $IDEE$impl$utils;
IDEE.impl.utils = $IDEE$impl$utils;
IDEE.impl.utils.geojsonTo4326 = IDEEimplutilsModule.geojsonTo4326;
IDEE.language = {};
IDEE.language.addTranslation = IDEElanguageModule.addTranslation;
IDEE.language.configuration = IDEElanguageModule.configuration;
IDEE.language.getLang = IDEElanguageModule.getLang;
IDEE.language.getTranslation = IDEElanguageModule.getTranslation;
IDEE.language.getValue = IDEElanguageModule.getValue;
IDEE.language.setLang = IDEElanguageModule.setLang;
IDEE.layer = {};
IDEE.layer.GenericRaster = $IDEE$layer$GenericRaster;
IDEE.layer.GenericVector = $IDEE$layer$GenericVector;
IDEE.layer.GeoJSON = $IDEE$layer$GeoJSON;
IDEE.layer.GeoPackage = $IDEE$layer$GeoPackage;
IDEE.layer.GeoPackageTile = $IDEE$layer$GeoPackageTile;
IDEE.layer.GeoTIFF = $IDEE$layer$GeoTIFF;
IDEE.layer.KML = $IDEE$layer$KML;
IDEE.layer.LayerGroup = $IDEE$layer$LayerGroup;
IDEE.layer.MBTiles = $IDEE$layer$MBTiles;
IDEE.layer.MBTilesVector = $IDEE$layer$MBTilesVector;
IDEE.layer.MBTilesVector.mode = IDEElayerMBTilesVectorModule.mode;
IDEE.layer.MVT = $IDEE$layer$MVT;
IDEE.layer.MVT.mode = IDEElayerMVTModule.mode;
IDEE.layer.MapLibre = $IDEE$layer$MapLibre;
IDEE.layer.OGCAPIFeatures = $IDEE$layer$OGCAPIFeatures;
IDEE.layer.OSM = $IDEE$layer$OSM;
IDEE.layer.Section = $IDEE$layer$Section;
IDEE.layer.TMS = $IDEE$layer$TMS;
IDEE.layer.Terrain = $IDEE$layer$Terrain;
IDEE.layer.Tiles3D = $IDEE$layer$Tiles3D;
IDEE.layer.Vector = $IDEE$layer$Vector;
IDEE.layer.WFS = $IDEE$layer$WFS;
IDEE.layer.WMC = $IDEE$layer$WMC;
IDEE.layer.WMS = $IDEE$layer$WMS;
IDEE.layer.WMTS = $IDEE$layer$WMTS;
IDEE.layer.XYZ = $IDEE$layer$XYZ;
IDEE.layer.type = {};
IDEE.layer.type.GenericRaster = IDEElayertypeModule.GenericRaster;
IDEE.layer.type.GenericVector = IDEElayertypeModule.GenericVector;
IDEE.layer.type.GeoJSON = IDEElayertypeModule.GeoJSON;
IDEE.layer.type.GeoPackage = IDEElayertypeModule.GeoPackage;
IDEE.layer.type.GeoPackageTile = IDEElayertypeModule.GeoPackageTile;
IDEE.layer.type.GeoTIFF = IDEElayertypeModule.GeoTIFF;
IDEE.layer.type.KML = IDEElayertypeModule.KML;
IDEE.layer.type.LayerGroup = IDEElayertypeModule.LayerGroup;
IDEE.layer.type.MBTiles = IDEElayertypeModule.MBTiles;
IDEE.layer.type.MBTilesVector = IDEElayertypeModule.MBTilesVector;
IDEE.layer.type.MVT = IDEElayertypeModule.MVT;
IDEE.layer.type.MapLibre = IDEElayertypeModule.MapLibre;
IDEE.layer.type.OGCAPIFeatures = IDEElayertypeModule.OGCAPIFeatures;
IDEE.layer.type.OSM = IDEElayertypeModule.OSM;
IDEE.layer.type.TMS = IDEElayertypeModule.TMS;
IDEE.layer.type.Tiles3D = IDEElayertypeModule.Tiles3D;
IDEE.layer.type.Vector = IDEElayertypeModule.Vector;
IDEE.layer.type.WFS = IDEElayertypeModule.WFS;
IDEE.layer.type.WMC = IDEElayertypeModule.WMC;
IDEE.layer.type.WMS = IDEElayertypeModule.WMS;
IDEE.layer.type.WMTS = IDEElayertypeModule.WMTS;
IDEE.layer.type.XYZ = IDEElayertypeModule.XYZ;
IDEE.loadFiles = {};
IDEE.loadFiles.addFileToMap = IDEEloadFilesModule.addFileToMap;
IDEE.loadFiles.loadFeaturesFromSource = IDEEloadFilesModule.loadFeaturesFromSource;
IDEE.loadFiles.loadFeaturesLoadFilesImpl = IDEEloadFilesModule.loadFeaturesLoadFilesImpl;
IDEE.loadFiles.loadGeotiffLayer = IDEEloadFilesModule.loadGeotiffLayer;
IDEE.map = IDEEModule.map;
IDEE.parameter = $IDEE$parameter;
IDEE.parameter = $IDEE$parameter;
IDEE.parameter.extentConstrains = IDEEparameterModule.extentConstrains;
IDEE.parameter.geojson = IDEEparameterModule.geojson;
IDEE.parameter.geotiff = IDEEparameterModule.geotiff;
IDEE.parameter.getBlobGeoTIFF = IDEEparameterModule.getBlobGeoTIFF;
IDEE.parameter.getCQLWFS = IDEEparameterModule.getCQLWFS;
IDEE.parameter.getConditionalOGC = IDEEparameterModule.getConditionalOGC;
IDEE.parameter.getDisplayInLayerSwitcherGeoTIFF = IDEEparameterModule.getDisplayInLayerSwitcherGeoTIFF;
IDEE.parameter.getDisplayInLayerSwitcherTerrain = IDEEparameterModule.getDisplayInLayerSwitcherTerrain;
IDEE.parameter.getDisplayInLayerSwitcherTiles3D = IDEEparameterModule.getDisplayInLayerSwitcherTiles3D;
IDEE.parameter.getDisplayInLayerSwitcherWMS = IDEEparameterModule.getDisplayInLayerSwitcherWMS;
IDEE.parameter.getDisplayInLayerSwitcherWMTS = IDEEparameterModule.getDisplayInLayerSwitcherWMTS;
IDEE.parameter.getExtraParameter = IDEEparameterModule.getExtraParameter;
IDEE.parameter.getExtractGeoJSON = IDEEparameterModule.getExtractGeoJSON;
IDEE.parameter.getExtractGeoTIFF = IDEEparameterModule.getExtractGeoTIFF;
IDEE.parameter.getExtractKML = IDEEparameterModule.getExtractKML;
IDEE.parameter.getExtractMBTilesVector = IDEEparameterModule.getExtractMBTilesVector;
IDEE.parameter.getExtractOGC = IDEEparameterModule.getExtractOGC;
IDEE.parameter.getExtractWFS = IDEEparameterModule.getExtractWFS;
IDEE.parameter.getFormatWMTS = IDEEparameterModule.getFormatWMTS;
IDEE.parameter.getGeometryWFS = IDEEparameterModule.getGeometryWFS;
IDEE.parameter.getIdsWFS = IDEEparameterModule.getIdsWFS;
IDEE.parameter.getLabelKML = IDEEparameterModule.getLabelKML;
IDEE.parameter.getLegendGeoJSON = IDEEparameterModule.getLegendGeoJSON;
IDEE.parameter.getLegendGeoTIFF = IDEEparameterModule.getLegendGeoTIFF;
IDEE.parameter.getLegendKML = IDEEparameterModule.getLegendKML;
IDEE.parameter.getLegendMBTiles = IDEEparameterModule.getLegendMBTiles;
IDEE.parameter.getLegendMBTilesVector = IDEEparameterModule.getLegendMBTilesVector;
IDEE.parameter.getLegendMVT = IDEEparameterModule.getLegendMVT;
IDEE.parameter.getLegendTerrain = IDEEparameterModule.getLegendTerrain;
IDEE.parameter.getLegendTiles3D = IDEEparameterModule.getLegendTiles3D;
IDEE.parameter.getLegendWFS = IDEEparameterModule.getLegendWFS;
IDEE.parameter.getLegendWMS = IDEEparameterModule.getLegendWMS;
IDEE.parameter.getLegendWMTS = IDEEparameterModule.getLegendWMTS;
IDEE.parameter.getMatrixSetWMTS = IDEEparameterModule.getMatrixSetWMTS;
IDEE.parameter.getMaxExtentMBTiles = IDEEparameterModule.getMaxExtentMBTiles;
IDEE.parameter.getMaxExtentMBTilesVector = IDEEparameterModule.getMaxExtentMBTilesVector;
IDEE.parameter.getMaxExtentWMS = IDEEparameterModule.getMaxExtentWMS;
IDEE.parameter.getMaxZoomLevelMBTiles = IDEEparameterModule.getMaxZoomLevelMBTiles;
IDEE.parameter.getMergeLayersWMS = IDEEparameterModule.getMergeLayersWMS;
IDEE.parameter.getNameGeoJSON = IDEEparameterModule.getNameGeoJSON;
IDEE.parameter.getNameGeoTIFF = IDEEparameterModule.getNameGeoTIFF;
IDEE.parameter.getNameKML = IDEEparameterModule.getNameKML;
IDEE.parameter.getNameMBTiles = IDEEparameterModule.getNameMBTiles;
IDEE.parameter.getNameMBTilesVector = IDEEparameterModule.getNameMBTilesVector;
IDEE.parameter.getNameMVT = IDEEparameterModule.getNameMVT;
IDEE.parameter.getNameTMS = IDEEparameterModule.getNameTMS;
IDEE.parameter.getNameTerrain = IDEEparameterModule.getNameTerrain;
IDEE.parameter.getNameTiles3D = IDEEparameterModule.getNameTiles3D;
IDEE.parameter.getNameWFS = IDEEparameterModule.getNameWFS;
IDEE.parameter.getNameWMC = IDEEparameterModule.getNameWMC;
IDEE.parameter.getNameWMS = IDEEparameterModule.getNameWMS;
IDEE.parameter.getNameWMTS = IDEEparameterModule.getNameWMTS;
IDEE.parameter.getNameXYZ = IDEEparameterModule.getNameXYZ;
IDEE.parameter.getNamespaceWFS = IDEEparameterModule.getNamespaceWFS;
IDEE.parameter.getNormalizeGeoTIFF = IDEEparameterModule.getNormalizeGeoTIFF;
IDEE.parameter.getOpacityMBTiles = IDEEparameterModule.getOpacityMBTiles;
IDEE.parameter.getOptionsWFS = IDEEparameterModule.getOptionsWFS;
IDEE.parameter.getOptionsWMC = IDEEparameterModule.getOptionsWMC;
IDEE.parameter.getOptionsWMS = IDEEparameterModule.getOptionsWMS;
IDEE.parameter.getOptionsWMTS = IDEEparameterModule.getOptionsWMTS;
IDEE.parameter.getProjectionGeoTIFF = IDEEparameterModule.getProjectionGeoTIFF;
IDEE.parameter.getQueryableWMS = IDEEparameterModule.getQueryableWMS;
IDEE.parameter.getQueryableWMTS = IDEEparameterModule.getQueryableWMTS;
IDEE.parameter.getSldVersion = IDEEparameterModule.getSldVersion;
IDEE.parameter.getSourceGeoJSON = IDEEparameterModule.getSourceGeoJSON;
IDEE.parameter.getSourceMBTiles = IDEEparameterModule.getSourceMBTiles;
IDEE.parameter.getSourceMBTilesVector = IDEEparameterModule.getSourceMBTilesVector;
IDEE.parameter.getStyleGeoJSON = IDEEparameterModule.getStyleGeoJSON;
IDEE.parameter.getStyleMBTilesVector = IDEEparameterModule.getStyleMBTilesVector;
IDEE.parameter.getStyleOGC = IDEEparameterModule.getStyleOGC;
IDEE.parameter.getStyleWFS = IDEEparameterModule.getStyleWFS;
IDEE.parameter.getStylesWMS = IDEEparameterModule.getStylesWMS;
IDEE.parameter.getTemplateKML = IDEEparameterModule.getTemplateKML;
IDEE.parameter.getTemplateMBTilesVector = IDEEparameterModule.getTemplateMBTilesVector;
IDEE.parameter.getTemplateMVT = IDEEparameterModule.getTemplateMVT;
IDEE.parameter.getTemplateOGC = IDEEparameterModule.getTemplateOGC;
IDEE.parameter.getTemplateWFS = IDEEparameterModule.getTemplateWFS;
IDEE.parameter.getTileLoadFunctionMBTiles = IDEEparameterModule.getTileLoadFunctionMBTiles;
IDEE.parameter.getTileLoadFunctionMBTilesVector = IDEEparameterModule.getTileLoadFunctionMBTilesVector;
IDEE.parameter.getTileSizeMBTiles = IDEEparameterModule.getTileSizeMBTiles;
IDEE.parameter.getTileSizeMBTilesVector = IDEEparameterModule.getTileSizeMBTilesVector;
IDEE.parameter.getTiledWMS = IDEEparameterModule.getTiledWMS;
IDEE.parameter.getTransparentGeoTIFF = IDEEparameterModule.getTransparentGeoTIFF;
IDEE.parameter.getTransparentMBTiles = IDEEparameterModule.getTransparentMBTiles;
IDEE.parameter.getTransparentWMS = IDEEparameterModule.getTransparentWMS;
IDEE.parameter.getTransparentWMTS = IDEEparameterModule.getTransparentWMTS;
IDEE.parameter.getType = IDEEparameterModule.getType;
IDEE.parameter.getURLGeoJSON = IDEEparameterModule.getURLGeoJSON;
IDEE.parameter.getURLGeoTIFF = IDEEparameterModule.getURLGeoTIFF;
IDEE.parameter.getURLKML = IDEEparameterModule.getURLKML;
IDEE.parameter.getURLMBTiles = IDEEparameterModule.getURLMBTiles;
IDEE.parameter.getURLMBTilesVector = IDEEparameterModule.getURLMBTilesVector;
IDEE.parameter.getURLMVT = IDEEparameterModule.getURLMVT;
IDEE.parameter.getURLTerrain = IDEEparameterModule.getURLTerrain;
IDEE.parameter.getURLTiles3D = IDEEparameterModule.getURLTiles3D;
IDEE.parameter.getURLWFS = IDEEparameterModule.getURLWFS;
IDEE.parameter.getURLWMC = IDEEparameterModule.getURLWMC;
IDEE.parameter.getURLWMS = IDEEparameterModule.getURLWMS;
IDEE.parameter.getURLWMTS = IDEEparameterModule.getURLWMTS;
IDEE.parameter.getURLXYZSource = IDEEparameterModule.getURLXYZSource;
IDEE.parameter.getUseCapabilitiesWMS = IDEEparameterModule.getUseCapabilitiesWMS;
IDEE.parameter.getVersionWFS = IDEEparameterModule.getVersionWFS;
IDEE.parameter.getVersionWMS = IDEEparameterModule.getVersionWMS;
IDEE.parameter.getVisibilityGeoTIFF = IDEEparameterModule.getVisibilityGeoTIFF;
IDEE.parameter.getVisibilityKML = IDEEparameterModule.getVisibilityKML;
IDEE.parameter.getVisibilityMBTiles = IDEEparameterModule.getVisibilityMBTiles;
IDEE.parameter.getVisibilityMBTilesVector = IDEEparameterModule.getVisibilityMBTilesVector;
IDEE.parameter.getVisibilityTerrain = IDEEparameterModule.getVisibilityTerrain;
IDEE.parameter.getVisibilityTiles3D = IDEEparameterModule.getVisibilityTiles3D;
IDEE.parameter.getVisibilityWMS = IDEEparameterModule.getVisibilityWMS;
IDEE.parameter.getVisibilityWMTS = IDEEparameterModule.getVisibilityWMTS;
IDEE.parameter.kml = IDEEparameterModule.kml;
IDEE.parameter.layer = IDEEparameterModule.layer;
IDEE.parameter.maxExtent = IDEEparameterModule.maxExtent;
IDEE.parameter.maxZoom = IDEEparameterModule.maxZoom;
IDEE.parameter.mbtiles = $IDEE$parameter$mbtiles;
IDEE.parameter.mbtiles = IDEEparameterModule.mbtiles;
IDEE.parameter.mbtilesvector = $IDEE$parameter$mbtilesvector;
IDEE.parameter.mbtilesvector = IDEEparameterModule.mbtilesvector;
IDEE.parameter.minZoom = IDEEparameterModule.minZoom;
IDEE.parameter.multiWorld = IDEEparameterModule.multiWorld;
IDEE.parameter.mvt = IDEEparameterModule.mvt;
IDEE.parameter.ogcapifeatures = IDEEparameterModule.ogcapifeatures;
IDEE.parameter.projection = IDEEparameterModule.projection;
IDEE.parameter.resolutions = IDEEparameterModule.resolutions;
IDEE.parameter.terrain = IDEEparameterModule.terrain;
IDEE.parameter.tiles3d = IDEEparameterModule.tiles3d;
IDEE.parameter.tms = $IDEE$parameter$tms;
IDEE.parameter.tms = IDEEparameterModule.tms;
IDEE.parameter.wfs = IDEEparameterModule.wfs;
IDEE.parameter.wmc = IDEEparameterModule.wmc;
IDEE.parameter.wms = IDEEparameterModule.wms;
IDEE.parameter.wmts = IDEEparameterModule.wmts;
IDEE.parameter.xyz = $IDEE$parameter$xyz;
IDEE.parameter.xyz = IDEEparameterModule.xyz;
IDEE.parameter.zoom = IDEEparameterModule.zoom;
IDEE.parameter.zoomConstrains = IDEEparameterModule.zoomConstrains;
IDEE.polyfill = $IDEE$polyfill;
IDEE.proxy = IDEEModule.proxy;
IDEE.remote = $IDEE$remote;
IDEE.remote.Response = $IDEE$remote$Response;
IDEE.remote.createScriptTag = IDEEremoteModule.createScriptTag;
IDEE.remote.get = IDEEremoteModule.get;
IDEE.remote.method = IDEEremoteModule.method;
IDEE.remote.post = IDEEremoteModule.post;
IDEE.stac = {};
IDEE.stac.Catalog = $IDEE$stac$Catalog;
IDEE.style = {};
IDEE.style.Category = $IDEE$style$Category;
IDEE.style.Chart = $IDEE$style$Chart;
IDEE.style.Choropleth = $IDEE$style$Choropleth;
IDEE.style.Cluster = $IDEE$style$Cluster;
IDEE.style.Composite = $IDEE$style$Composite;
IDEE.style.Feature = $IDEE$style$Feature;
IDEE.style.FlowLine = $IDEE$style$FlowLine;
IDEE.style.Font = $IDEE$style$Font;
IDEE.style.Generic = $IDEE$style$Generic;
IDEE.style.Heatmap = $IDEE$style$Heatmap;
IDEE.style.Line = $IDEE$style$Line;
IDEE.style.Point = $IDEE$style$Point;
IDEE.style.Polygon = $IDEE$style$Polygon;
IDEE.style.Proportional = $IDEE$style$Proportional;
IDEE.style.Proportional.getMinMaxValues = IDEEstyleProportionalModule.getMinMaxValues;
IDEE.style.Raster = $IDEE$style$Raster;
IDEE.style.Simple = $IDEE$style$Simple;
IDEE.style.Tiles3D = $IDEE$style$Tiles3D;
IDEE.style.align = {};
IDEE.style.align.CENTER = IDEEstylealignModule.CENTER;
IDEE.style.align.JUSTIFY = IDEEstylealignModule.JUSTIFY;
IDEE.style.align.LEFT = IDEEstylealignModule.LEFT;
IDEE.style.align.RIGHT = IDEEstylealignModule.RIGHT;
IDEE.style.baseline = {};
IDEE.style.baseline.ALPHABETIC = IDEEstylebaselineModule.ALPHABETIC;
IDEE.style.baseline.BASELINE = IDEEstylebaselineModule.BASELINE;
IDEE.style.baseline.BOTTOM = IDEEstylebaselineModule.BOTTOM;
IDEE.style.baseline.CENTER = IDEEstylebaselineModule.CENTER;
IDEE.style.baseline.HANGING = IDEEstylebaselineModule.HANGING;
IDEE.style.baseline.IDEOGRAPHIC = IDEEstylebaselineModule.IDEOGRAPHIC;
IDEE.style.baseline.MIDDLE = IDEEstylebaselineModule.MIDDLE;
IDEE.style.baseline.TOP = IDEEstylebaselineModule.TOP;
IDEE.style.chart = {};
IDEE.style.chart.Variable = $IDEE$style$chart$Variable;
IDEE.style.chart.schemes = IDEEstylechartModule.schemes;
IDEE.style.chart.types = IDEEstylechartModule.types;
IDEE.style.form = {};
IDEE.style.form.BAN = IDEEstyleformModule.BAN;
IDEE.style.form.BLAZON = IDEEstyleformModule.BLAZON;
IDEE.style.form.BOOKMARK = IDEEstyleformModule.BOOKMARK;
IDEE.style.form.BUBBLE = IDEEstyleformModule.BUBBLE;
IDEE.style.form.CIRCLE = IDEEstyleformModule.CIRCLE;
IDEE.style.form.COMA = IDEEstyleformModule.COMA;
IDEE.style.form.DIAMOND = IDEEstyleformModule.DIAMOND;
IDEE.style.form.HEXAGON = IDEEstyleformModule.HEXAGON;
IDEE.style.form.LOZENGE = IDEEstyleformModule.LOZENGE;
IDEE.style.form.MARKER = IDEEstyleformModule.MARKER;
IDEE.style.form.NONE = IDEEstyleformModule.NONE;
IDEE.style.form.POI = IDEEstyleformModule.POI;
IDEE.style.form.SHIELD = IDEEstyleformModule.SHIELD;
IDEE.style.form.SIGN = IDEEstyleformModule.SIGN;
IDEE.style.form.SQUARE = IDEEstyleformModule.SQUARE;
IDEE.style.form.TRIANGLE = IDEEstyleformModule.TRIANGLE;
IDEE.style.heightReference = {};
IDEE.style.heightReference.CLAMP_TO_3D_TILE = IDEEstyleheightReferenceModule.CLAMP_TO_3D_TILE;
IDEE.style.heightReference.CLAMP_TO_GROUND = IDEEstyleheightReferenceModule.CLAMP_TO_GROUND;
IDEE.style.heightReference.CLAMP_TO_TERRAIN = IDEEstyleheightReferenceModule.CLAMP_TO_TERRAIN;
IDEE.style.heightReference.NONE = IDEEstyleheightReferenceModule.NONE;
IDEE.style.heightReference.RELATIVE_TO_3D_TILE = IDEEstyleheightReferenceModule.RELATIVE_TO_3D_TILE;
IDEE.style.heightReference.RELATIVE_TO_GROUND = IDEEstyleheightReferenceModule.RELATIVE_TO_GROUND;
IDEE.style.heightReference.RELATIVE_TO_TERRAIN = IDEEstyleheightReferenceModule.RELATIVE_TO_TERRAIN;
IDEE.style.pattern = {};
IDEE.style.pattern.BRECCIA = IDEEstylepatternModule.BRECCIA;
IDEE.style.pattern.BRICK = IDEEstylepatternModule.BRICK;
IDEE.style.pattern.CAPS = IDEEstylepatternModule.CAPS;
IDEE.style.pattern.CEMETRY = IDEEstylepatternModule.CEMETRY;
IDEE.style.pattern.CHAOS = IDEEstylepatternModule.CHAOS;
IDEE.style.pattern.CHARACTER = IDEEstylepatternModule.CHARACTER;
IDEE.style.pattern.CIRCLE = IDEEstylepatternModule.CIRCLE;
IDEE.style.pattern.CLAY = IDEEstylepatternModule.CLAY;
IDEE.style.pattern.COAL = IDEEstylepatternModule.COAL;
IDEE.style.pattern.CONGLOMERATE = IDEEstylepatternModule.CONGLOMERATE;
IDEE.style.pattern.CROSS = IDEEstylepatternModule.CROSS;
IDEE.style.pattern.CROSSES = IDEEstylepatternModule.CROSSES;
IDEE.style.pattern.DOLOMITE = IDEEstylepatternModule.DOLOMITE;
IDEE.style.pattern.DOT = IDEEstylepatternModule.DOT;
IDEE.style.pattern.FLOODED = IDEEstylepatternModule.FLOODED;
IDEE.style.pattern.FOREST = IDEEstylepatternModule.FOREST;
IDEE.style.pattern.GRASS = IDEEstylepatternModule.GRASS;
IDEE.style.pattern.GRAVEL = IDEEstylepatternModule.GRAVEL;
IDEE.style.pattern.HATCH = IDEEstylepatternModule.HATCH;
IDEE.style.pattern.HEXAGON = IDEEstylepatternModule.HEXAGON;
IDEE.style.pattern.ICON = IDEEstylepatternModule.ICON;
IDEE.style.pattern.IMAGE = IDEEstylepatternModule.IMAGE;
IDEE.style.pattern.NYLON = IDEEstylepatternModule.NYLON;
IDEE.style.pattern.PINE = IDEEstylepatternModule.PINE;
IDEE.style.pattern.PINES = IDEEstylepatternModule.PINES;
IDEE.style.pattern.ROCK = IDEEstylepatternModule.ROCK;
IDEE.style.pattern.ROCKS = IDEEstylepatternModule.ROCKS;
IDEE.style.pattern.SAND = IDEEstylepatternModule.SAND;
IDEE.style.pattern.SCRUB = IDEEstylepatternModule.SCRUB;
IDEE.style.pattern.SQUARE = IDEEstylepatternModule.SQUARE;
IDEE.style.pattern.SWAMP = IDEEstylepatternModule.SWAMP;
IDEE.style.pattern.TILE = IDEEstylepatternModule.TILE;
IDEE.style.pattern.TREE = IDEEstylepatternModule.TREE;
IDEE.style.pattern.VINE = IDEEstylepatternModule.VINE;
IDEE.style.pattern.WAVE = IDEEstylepatternModule.WAVE;
IDEE.style.pattern.WOVEN = IDEEstylepatternModule.WOVEN;
IDEE.style.quantification = {};
IDEE.style.quantification.ARITHMETIC_PROGRESSION = IDEEstylequantificationModule.ARITHMETIC_PROGRESSION;
IDEE.style.quantification.EQUAL_INTERVAL = IDEEstylequantificationModule.EQUAL_INTERVAL;
IDEE.style.quantification.GEOMETRIC_PROGRESSION = IDEEstylequantificationModule.GEOMETRIC_PROGRESSION;
IDEE.style.quantification.JENKS = IDEEstylequantificationModule.JENKS;
IDEE.style.quantification.MEDIA_SIGMA = IDEEstylequantificationModule.MEDIA_SIGMA;
IDEE.style.quantification.QUANTILE = IDEEstylequantificationModule.QUANTILE;
IDEE.style.quantification.hasNegativeValue = IDEEstylequantificationModule.hasNegativeValue;
IDEE.style.quantification.uniqueArray = IDEEstylequantificationModule.uniqueArray;
IDEE.style.state = {};
IDEE.style.state.DEFAULT = IDEEstylestateModule.DEFAULT;
IDEE.style.state.NEW = IDEEstylestateModule.NEW;
IDEE.style.state.SELECTED = IDEEstylestateModule.SELECTED;
IDEE.style.textoverflow = {};
IDEE.style.textoverflow.ELLIPSIS = IDEEstyletextoverflowModule.ELLIPSIS;
IDEE.style.textoverflow.HIDDEN = IDEEstyletextoverflowModule.HIDDEN;
IDEE.style.textoverflow.VISIBLE = IDEEstyletextoverflowModule.VISIBLE;
IDEE.style.utils = $IDEE$style$utils;
IDEE.template = {};
IDEE.template.add = IDEEtemplateModule.add;
IDEE.template.compileSync = IDEEtemplateModule.compileSync;
IDEE.toast = {};
IDEE.toast.error = IDEEtoastModule.error;
IDEE.toast.info = IDEEtoastModule.info;
IDEE.toast.remove = IDEEtoastModule.remove;
IDEE.toast.removeElement = IDEEtoastModule.removeElement;
IDEE.toast.show = IDEEtoastModule.show;
IDEE.toast.success = IDEEtoastModule.success;
IDEE.toast.warning = IDEEtoastModule.warning;
IDEE.ui = {};
IDEE.ui.Panel = $IDEE$ui$Panel;
IDEE.ui.position = {};
IDEE.ui.position.BL = IDEEuipositionModule.BL;
IDEE.ui.position.BR = IDEEuipositionModule.BR;
IDEE.ui.position.TL = IDEEuipositionModule.TL;
IDEE.ui.position.TR = IDEEuipositionModule.TR;
IDEE.units = {};
IDEE.units.DOTS_PER_INCH = IDEEunitsModule.DOTS_PER_INCH;
IDEE.units.INCHES_PER_UNIT = IDEEunitsModule.INCHES_PER_UNIT;
IDEE.useproxy = IDEEModule.useproxy;
IDEE.utils = $IDEE$utils;
IDEE.utils.ObjectToArrayExtent = IDEEutilsModule.ObjectToArrayExtent;
IDEE.utils.addParameters = IDEEutilsModule.addParameters;
IDEE.utils.beautifyAttribute = IDEEutilsModule.beautifyAttribute;
IDEE.utils.beautifyAttributeName = IDEEutilsModule.beautifyAttributeName;
IDEE.utils.beautifyString = IDEEutilsModule.beautifyString;
IDEE.utils.bytesToBase64 = IDEEutilsModule.bytesToBase64;
IDEE.utils.classToggle = IDEEutilsModule.classToggle;
IDEE.utils.concatUrlPaths = IDEEutilsModule.concatUrlPaths;
IDEE.utils.copyImageClipBoard = IDEEutilsModule.copyImageClipBoard;
IDEE.utils.decodeBase64 = IDEEutilsModule.decodeBase64;
IDEE.utils.decodeHtml = IDEEutilsModule.decodeHtml;
IDEE.utils.defineFunctionFromString = IDEEutilsModule.defineFunctionFromString;
IDEE.utils.dragElement = IDEEutilsModule.dragElement;
IDEE.utils.draggabillyElement = IDEEutilsModule.draggabillyElement;
IDEE.utils.draggabillyPlugin = IDEEutilsModule.draggabillyPlugin;
IDEE.utils.drawDynamicStyle = IDEEutilsModule.drawDynamicStyle;
IDEE.utils.enableTouchScroll = IDEEutilsModule.enableTouchScroll;
IDEE.utils.encodeBase64 = IDEEutilsModule.encodeBase64;
IDEE.utils.escapeJSCode = IDEEutilsModule.escapeJSCode;
IDEE.utils.escapeXSS = IDEEutilsModule.escapeXSS;
IDEE.utils.extend = IDEEutilsModule.extend;
IDEE.utils.extendsObj = IDEEutilsModule.extendsObj;
IDEE.utils.fillResolutions = IDEEutilsModule.fillResolutions;
IDEE.utils.filterList = IDEEutilsModule.filterList;
IDEE.utils.findUrls = IDEEutilsModule.findUrls;
IDEE.utils.generateColorScale = IDEEutilsModule.generateColorScale;
IDEE.utils.generateIntervals = IDEEutilsModule.generateIntervals;
IDEE.utils.generateRandom = IDEEutilsModule.generateRandom;
IDEE.utils.generateResolutionsFromExtent = IDEEutilsModule.generateResolutionsFromExtent;
IDEE.utils.generateResolutionsFromScales = IDEEutilsModule.generateResolutionsFromScales;
IDEE.utils.getEnvolvedExtent = IDEEutilsModule.getEnvolvedExtent;
IDEE.utils.getFeaturesExtent = IDEEutilsModule.getFeaturesExtent;
IDEE.utils.getImageMap = IDEEutilsModule.getImageMap;
IDEE.utils.getImageSize = IDEEutilsModule.getImageSize;
IDEE.utils.getOpacityFromRgba = IDEEutilsModule.getOpacityFromRgba;
IDEE.utils.getParameterValue = IDEEutilsModule.getParameterValue;
IDEE.utils.getResolutionFromScale = IDEEutilsModule.getResolutionFromScale;
IDEE.utils.getRgba = IDEEutilsModule.getRgba;
IDEE.utils.getScaleFromResolution = IDEEutilsModule.getScaleFromResolution;
IDEE.utils.getSystem = IDEEutilsModule.getSystem;
IDEE.utils.getTextFromHtml = IDEEutilsModule.getTextFromHtml;
IDEE.utils.getWMSGetCapabilitiesUrl = IDEEutilsModule.getWMSGetCapabilitiesUrl;
IDEE.utils.getWMTSCapabilities = IDEEutilsModule.getWMTSCapabilities;
IDEE.utils.getWMTSGetCapabilitiesUrl = IDEEutilsModule.getWMTSGetCapabilitiesUrl;
IDEE.utils.htmlToString = IDEEutilsModule.htmlToString;
IDEE.utils.includes = IDEEutilsModule.includes;
IDEE.utils.inverseColor = IDEEutilsModule.inverseColor;
IDEE.utils.isArray = IDEEutilsModule.isArray;
IDEE.utils.isBoolean = IDEEutilsModule.isBoolean;
IDEE.utils.isDynamic = IDEEutilsModule.isDynamic;
IDEE.utils.isFunction = IDEEutilsModule.isFunction;
IDEE.utils.isGeometryType = IDEEutilsModule.isGeometryType;
IDEE.utils.isNull = IDEEutilsModule.isNull;
IDEE.utils.isNullOrEmpty = IDEEutilsModule.isNullOrEmpty;
IDEE.utils.isNumber = IDEEutilsModule.isNumber;
IDEE.utils.isObject = IDEEutilsModule.isObject;
IDEE.utils.isPositiveNumber = IDEEutilsModule.isPositiveNumber;
IDEE.utils.isString = IDEEutilsModule.isString;
IDEE.utils.isUndefined = IDEEutilsModule.isUndefined;
IDEE.utils.isUrl = IDEEutilsModule.isUrl;
IDEE.utils.modifySVG = IDEEutilsModule.modifySVG;
IDEE.utils.normalize = IDEEutilsModule.normalize;
IDEE.utils.parseCRSWKTtoJSON = IDEEutilsModule.parseCRSWKTtoJSON;
IDEE.utils.removeHTML = IDEEutilsModule.removeHTML;
IDEE.utils.replaceNode = IDEEutilsModule.replaceNode;
IDEE.utils.reproject = IDEEutilsModule.reproject;
IDEE.utils.returnPositionHtmlElement = IDEEutilsModule.returnPositionHtmlElement;
IDEE.utils.rgbToHex = IDEEutilsModule.rgbToHex;
IDEE.utils.rgbaToHex = IDEEutilsModule.rgbaToHex;
IDEE.utils.sameUrl = IDEEutilsModule.sameUrl;
IDEE.utils.setDynamicLegend = IDEEutilsModule.setDynamicLegend;
IDEE.utils.setEquals = IDEEutilsModule.setEquals;
IDEE.utils.stringToHtml = IDEEutilsModule.stringToHtml;
IDEE.utils.stringifyFunctions = IDEEutilsModule.stringifyFunctions;
IDEE.utils.styleComparator = IDEEutilsModule.styleComparator;
IDEE.utils.transfomContent = IDEEutilsModule.transfomContent;
IDEE.version = IDEEModule.version;
IDEE.window = $IDEE$window;
window['Handlebars'] = require('handlebars');
window['proj4'] = require('proj4');
window['Cesium'] = require('cesium');
window['jsts'] = require('jsts');
IDEE.plugin = {}